
import styled from "styled-components";
import scrollbar_decrement from "../../imgs/scrollbar_decrement.svg";
import scrollbar_increment from "../../imgs/scrollbar_increment.svg";
import scrollbar_increment_light from "../../imgs/scrollbar_increment_light.svg";
import scrollbar_decrement_light from "../../imgs/scrollbar_decrement_light.svg";
const ScrollContainer = styled.div`
  width: 100%;
  height: 350px;
  overflow-y: scroll;
  position: relative;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid white;
  &::-webkit-scrollbar {
    width: 20px;
    background: #4D4C87CC;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.2);
    background: ${(props) => props.theme.themeType === "dark" ? "#D0D0D0CC" : "#9D7CFF"};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.themeType === "dark" ?"#D0D0D0" : "#B0B3FF"};
  }
  &::-webkit-scrollbar-button:end {
    display: block;
  }
  &::-webkit-scrollbar-button:start {
    display: block;
  }
  &::-webkit-scrollbar-button:vertical:end:decrement {
    display: none;
  }
  &::-webkit-scrollbar-button:vertical:start:increment {
    display: none;
  }

  &::-webkit-scrollbar-button:vertical:increment {
    /* Down */
    background-image: url(${(props) => props.theme.themeType === "dark" ?scrollbar_increment : scrollbar_increment_light});
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center;
    display: none;
  }
  &::-webkit-scrollbar-button:vertical:decrement {
    /* Down */
    display: none;
    background-image: url(${(props) => props.theme.themeType === "dark" ?scrollbar_decrement : scrollbar_decrement_light});
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export default ScrollContainer